import { createElement } from 'react';
import withStyles, { WithStyles } from 'react-jss';
import flowRight from 'lodash.flowright';
import { observer } from 'mobx-react';
import { store, StaticPage } from '../store';
import Dialog from 'react-dialog';
import 'react-dialog/css/index.css';
import { observable } from 'mobx';
import NewWindow from 'react-new-window';
// import { SubMenu, MenuItem } from 'rc-menu';

const styles = {
    topMenuBar: {
        backgroundColor: '#051931',
        color: '#CDCED1',
        maxHeight: '60px',
        display: 'flex',
        justifyContent: ' space-between',

        alignItems: 'center',
    },
    input: {
        width: 150,
        height: 30,
        margin: 10,
    },
    item: {
        display: 'flex',
        flexDirection: 'row',

        margin: 15,
        color: '#CDCED1',
        marginRight: 30,
    },

    button: {
        width: 70,
        height: 30,
        marginLeft: 8,
        color: '#FFFFFF',
        backgroundColor: 'transparent',
        borderRadius: '2px',
        border: '1px solid #20d29f',
        cursor: 'pointer',
        zIndex: 20,
    },
    savebutton: {
        backgroundColor: '#20d29f',
    },
    fetchbutton: {
        width: 'auto',
        height: 30,
        color: '#FFFFFF',
        backgroundColor: '#F5404D',
        border: '1px solid #F5404D',
        fontSize: 13,
        cursor: 'pointer',
        zIndex: 20,
        borderRadius: 2,
    },
    select: {
        width: 150,
        height: 30,
        color: '#FFFFFF',
        alignItems: 'center',
        lineHeight: 20,
        borderRadius: 3,
        justifyContent: 'center',
        backgroundColor: '#051931',
        border: '1px solid #acafe1',
        transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0s, color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0s, fill 150ms cubic-bezier(0.4, 0, 0.2, 1) 0s',
    },
    header: {
        margin: 8,
        color: '#FFFFFF',
        fontSize: 13,
    },
    title: {
        display: 'flex',
        flexDirection: 'row',
        color: '#FFFFFF',
        fontSize: 20,
    },
    dialog: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
    },
    Order: {
        width: 50,
        height: 27,
        marginLeft: -8,
        marginRight: 10,
        textAlign: 'center',
        color: '#FFFFFF',
        fontSize: 13,
        backgroundColor: '#051931',
        border: '1px solid #acafe1',
    },
};

interface IProps extends WithStyles<typeof styles> {}

function handleSave() {
    if (store.callbacks.saveCb) {
        store.callbacks.saveCb(store.currentTemplate);
    }
}

function handleSaveAs(template_name: string) {
    let newTemplate = {
        ...store.currentTemplate,
        name: template_name,
        id: +new Date(),
    };
    store.currentTemplate = newTemplate;
    if (store.callbacks.saveCb) {
        store.callbacks.saveCb(newTemplate);
    }
}

function sendMail() {
    if (store.callbacks.testMailCb) {
        store.callbacks.testMailCb(emailDialogState.to, emailDialogState.subject, store.renderTemplate());
    }
}

function fetchOrder(num: number) {
    if (store.callbacks.fetchOrdercb) {
        return store.callbacks.fetchOrdercb(num);
    }
    return Promise.resolve('');
}

function handlePreview() {
    store.ui.isPreviewOpen = true;
    // store.renderTemplate();
}

function changeTemplate(templateId: number) {
    let template = store.templates.filter((t) => t.id == templateId)[0];
    store.currentTemplate = template;
}

function newTemplate() {
    store.currentTemplate = store.createDefaultTemplate();
}

let saveDialoState = observable({
    template_name: '',
});

let emailDialogState = observable({
    subject: '',
    to: '',
});
let fetchOrderState = observable({
    orderId: 0,
});

const TopMenuBar: React.FunctionComponent<IProps> = ({ classes }) => (
    <div className={classes.topMenuBar}>
        <div
            className={classes.title}
            style={{
                display: 'flex',
                justifyContent: 'column',
                paddingLeft: 19,
                textTransform: 'uppercase'
            }}>
            {' '}
            Visual Email Builder
        </div>
        <div
            style={{
                display: 'flex',
                justifyContent: 'column',
            }}>
            <div className={classes.item}>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-around',
                    }}>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}>
                        <span className={classes.header}>Currently Editing</span>
                        <select className={classes.select + ' selecttemplate'} value={store.currentTemplate.id} onChange={(e) => changeTemplate(+e.target.value)}>
                            {/* <option value={0}>--Select Template--</option> */}
                            {store.templates.map((t) => {
                                return (
                                    <option key={t.id} value={t.id}>
                                        {t.name}
                                    </option>
                                );
                            })}w
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div
                className={classes.button3 + ' button8'}
                style={{
                    paddingRight: 19,
                }}>
                {store.ui.isTestSaveAsOpen ? (
                    <Dialog
                        title="Save As"
                        onClose={() => (store.ui.isTestSaveAsOpen = false)}
                        modal={true}
                        buttons={[
                            {
                                text: 'Save As',
                                onClick: () => handleSaveAs(saveDialoState.template_name),
                            },
                        ]}>
                        <div className={classes.dialog}>
                            <span className={classes.header}>Template Name</span>
                            <input type="text" name="template_name" className={classes.input + ' templatename'} value={saveDialoState.template_name} onChange={(e) => (saveDialoState.template_name = e.target.value)} />
                        </div>
                    </Dialog>
                ) : null}
                <button className={classes.button + ' preview  button8'} onClick={() => handlePreview()}>
                    Preview
                </button>
                <button className={classes.button + ' saveas button8'} onClick={() => (store.ui.isTestSaveAsOpen = true)}>
                    Save As{' '}
                </button>
                <button className={classes.button + ' ' + classes.savebutton } onClick={handleSave}>
                    Save
                </button>
            </div>
            {store.ui.isPreviewOpen ? (
                <NewWindow copyStyles={true} onUnload={() => (store.ui.isPreviewOpen = false)} center="parent">
                    <StaticPage />
                </NewWindow>
            ) : null}
        </div>
    </div>
);

export default flowRight([withStyles(styles), observer])(TopMenuBar);
